
export enum UnipileAccountConnectionStatusEnum {
  CONNECTED = "CONNECTED",
  DISCONNECTED = "DISCONNECTED",
  DO_NOT_EXIST = "DO_NOT_EXIST",
}